import React, { useState } from 'react';
import { Megaphone } from 'lucide-react';
import axios from 'axios';
import { BACKEND_URL } from '../shared';
import { useConfirm } from '../../../components/admin/ConfirmDialog';

export default function ServidorTab({ showFeedback, onlineCount = 0 }) {
  const [msg, setMsg]       = useState('');
  const [sending, setSending] = useState(false);
  const [confirm, confirmDialog] = useConfirm();
  const remaining = 255 - msg.length;

  const sendAnnounce = async () => {
    if (!msg.trim()) return;
    const ok = await confirm({
      title: 'Enviar anuncio a todo el servidor', confirmLabel: 'Enviar anuncio',
      body: <>
        <span style={{ color: 'rgba(224,247,255,0.5)', fontSize: 12 }}>
          Lo verán en el chat los {onlineCount} {onlineCount === 1 ? 'jugador conectado' : 'jugadores conectados'} ahora mismo:
        </span>
        <div style={{ marginTop: 8, padding: '10px 12px', borderRadius: 8, background: 'rgba(0,0,0,0.35)', border: '1px solid rgba(255,209,0,0.25)', color: '#ffd100', fontFamily: 'monospace', fontSize: 13, whiteSpace: 'pre-wrap' }}>
          {msg.trim()}
        </div>
      </>,
    });
    if (!ok) return;
    setSending(true);
    try {
      await axios.post(
        `${BACKEND_URL}/api/admin/announce`,
        { message: msg.trim() },
        { withCredentials: true }
      );
      showFeedback('ok', 'Anuncio enviado a todos los jugadores conectados');
      setMsg('');
    } catch (err) {
      const detail = err?.response?.data?.detail || 'Error al enviar el anuncio';
      showFeedback('err', detail);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="admin-section anim-fade-up" style={{ animationDelay: '0.1s' }}>
      {confirmDialog}
      <div className="admin-section-header">
        <h2 className="admin-section-title">Anuncio en el servidor</h2>
      </div>

      <div style={{
        background: 'rgba(0,229,255,0.04)', border: '1px solid rgba(0,229,255,0.15)',
        borderRadius: 12, padding: '24px',
      }}>
        <p style={{ color: 'rgba(224,247,255,0.5)', fontSize: 13, margin: '0 0 16px' }}>
          El mensaje aparecerá en el chat de todos los jugadores conectados en ese momento como un anuncio del sistema.
        </p>

        <textarea
          value={msg}
          onChange={(e) => setMsg(e.target.value.slice(0, 255))}
          placeholder="Escribe el mensaje del anuncio..."
          rows={3}
          style={{
            width: '100%', boxSizing: 'border-box',
            background: 'rgba(0,0,0,0.3)', border: '1px solid rgba(0,229,255,0.2)',
            borderRadius: 8, padding: '12px 14px', resize: 'vertical',
            color: '#e0e8f0', fontSize: 14, fontFamily: 'inherit',
          }}
        />
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10,
        }}>
          <span style={{ color: remaining < 30 ? '#f87171' : 'rgba(224,247,255,0.3)', fontSize: 12 }}>
            {remaining} caracteres restantes
          </span>
          <button
            onClick={sendAnnounce}
            disabled={sending || !msg.trim()}
            style={{
              background: sending || !msg.trim() ? 'rgba(0,229,255,0.1)' : 'linear-gradient(135deg,#0077b6,#00b4d8)',
              border: '1px solid rgba(0,229,255,0.3)', borderRadius: 8,
              color: '#fff', fontWeight: 700, fontSize: 13, letterSpacing: 1,
              padding: '10px 28px', cursor: sending || !msg.trim() ? 'not-allowed' : 'pointer',
              display: 'flex', alignItems: 'center', gap: 8, transition: 'background 0.2s, border-color 0.2s',
            }}
          >
            <Megaphone size={15} />
            {sending ? 'ENVIANDO...' : 'ENVIAR ANUNCIO'}
          </button>
        </div>
      </div>
    </div>
  );
}
